<mat-form-field
  class="chip-list"
  [appearance]="appearance"
  [floatLabel]="myFloatLabel && myFloatLabel !== 'never' ? myFloatLabel : 'auto'"
>
  <mat-label>
    <span [class.required-label]="requiredInLabel">{{ placeholder }}</span>
  </mat-label>

  <mat-chip-grid #chipList>
    @if (positionOfInput === 'top') {
      <ng-container *ngTemplateOutlet="inputTemplate"></ng-container>
    }

    @for (pickedOption of pickedOptions; track pickedOption) {
      <mat-chip-row (removed)="removePickedOption(pickedOption)">
        {{ pickedOption }}
        <button matChipRemove>
          <span class="icon-remove" [inlineSVG]="'/icons/icon-close-no-color.svg'"></span>
        </button>
      </mat-chip-row>
    }

    @if (positionOfInput === 'bottom') {
      <ng-container *ngTemplateOutlet="inputTemplate"></ng-container>
    }
  </mat-chip-grid>

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    @if (openDropdownOnClick) {
      @for (filteredOption of filteredOptions | async; track filteredOption) {
        <mat-option [value]="filteredOption">
          {{ filteredOption }}
        </mat-option>
      }
    }
  </mat-autocomplete>

  <ng-template #inputTemplate>
    <input
      #optionInput
      [formControl]="control"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
      (focusout)="onInputFocusOut()"
      (click)="handleInputClick()"
    />
  </ng-template>
</mat-form-field>
